import { addProp } from "@pnp/odata";
import { _List } from "../lists/types.js";
import { ContentTypes } from "./types.js";
addProp(_List, "contentTypes", ContentTypes);
//# sourceMappingURL=list.js.map